import { extractNumber } from '@cred/shared/utils'
import { currency } from '@cred/shared/formatters'
import { allLenders } from './lenders-data'

export const minMaxLoanAmount = value => {
  const numberValue = extractNumber(value),
    allMinValues = allLenders.map(l => l.minAmount),
    minValue = Math.min(...allMinValues)
  let error

  if (numberValue < minValue) {
    error = `Please enter at least ${currency(minValue)}`
  }

  return error
}
